
function ImageLoading(){

    this.build();

}

ImageLoading.prototype.build = function(){

    $(window).on('transitionDone', function () {

        $('.image-loading img').each(function (index, elem) {

            ScrollTrigger.create({
                trigger: elem,
                start: 'top bottom',
                once: true,
                onEnter: function () {
                    $(elem).on('load', function () {
                        $(elem).parent().parent().addClass('is-loaded');
                    }).attr("src", $(elem).attr('src'));
                }
            });

        });

    });

};
